import { useEffect } from 'react';

import { Locale } from '@core/Entities/Locale/Locale.entity';
import { Close } from '@gds/Icons';
import { Typography } from '@gds/Typography/Typography';

import { ColorFilter } from '../Filters/Components/ColorFilter/ColorFilter';
import { FuelFilter } from '../Filters/Components/FuelFilter/FuelFilter';
import { GearboxFilter } from '../Filters/Components/GearboxFilter/GearboxFilter';
import { LocationFilter as LocationFilterFr } from '../Filters/Components/LocationFilter/LocationFilter';
import { LocationFilterUk } from '../Filters/Components/LocationFilter/LocationFilterUk';
import MakeFilter from '../Filters/Components/MakeFilter/MakeFilter';
import ModelFilter from '../Filters/Components/ModelFilter/ModelFilter';
import { PriceFilter } from '../Filters/Components/PriceFilter/PriceFilter';
import { SeatsFilter } from '../Filters/Components/SeatsFilter/SeatsFilter';

import { PlpCombinedFiltersMessages } from '../Filters/FilterPanel.entity';

import styles from './QuickFilters.module.css';
interface StickyFilterMenusProps {
  openQuickFilter: string | null;
  strings: PlpCombinedFiltersMessages;
  locale: Locale;
  setOpenQuickFilter: (value: string | null) => void;
}

export const StickyFilterMenus: React.FC<StickyFilterMenusProps> = ({
  openQuickFilter,
  strings,
  locale,
  setOpenQuickFilter,
}) => {
  useEffect(() => {
    if (openQuickFilter) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = '';
    }

    return () => {
      document.documentElement.style.overflow = '';
    };
  }, [openQuickFilter]);

  return (
    <div className={styles.stickyFilters}>
      {openQuickFilter && (
        <div className={styles.overlay} onClick={() => setOpenQuickFilter(null)}></div>
      )}
      <div className={styles.stickyFilterMenus}>
        {openQuickFilter === 'postcode_entry' && (
          <>
            <div className={styles.filterHeader}>
              <Typography variant="h6">{strings.postcode}</Typography>
              <Close onClick={() => setOpenQuickFilter(null)} />
            </div>
            <LocationFilterUk
              strings={strings}
              locale={locale}
              isPlpFiltersSeoEnabled
              tenant={undefined}
              applyButton
            />
          </>
        )}
        {openQuickFilter === 'color' && (
          <>
            <div className={styles.filterHeader}>
              <Typography variant="h6">{strings.color}</Typography>
              <Close onClick={() => setOpenQuickFilter(null)} />
            </div>
            <ColorFilter
              strings={strings}
              locale={locale}
              isPlpFiltersSeoEnabled
              tenant={undefined}
              applyButton
            />
          </>
        )}
        {openQuickFilter === 'price' && (
          <>
            <div className={styles.filterHeader}>
              <Typography variant="h6">{strings.price}</Typography>
              <Close onClick={() => setOpenQuickFilter(null)} />
            </div>
            <PriceFilter
              strings={strings}
              locale={locale}
              isPlpFiltersSeoEnabled
              tenant={undefined}
              applyButton
            />
          </>
        )}
        {openQuickFilter === 'seats' && (
          <>
            <div className={styles.filterHeader}>
              <Typography variant="h6">{strings.seats}</Typography>
              <Close onClick={() => setOpenQuickFilter(null)} />
            </div>
            <SeatsFilter
              strings={strings}
              locale={locale}
              isPlpFiltersSeoEnabled
              tenant={undefined}
              applyButton
            />
          </>
        )}
        {openQuickFilter === 'location' && (
          <>
            <div className={styles.filterHeader}>
              <Typography variant="h6">{strings.postcode}</Typography>
              <Close onClick={() => setOpenQuickFilter(null)} />
            </div>
            <LocationFilterFr
              strings={strings}
              locale={locale}
              isPlpFiltersSeoEnabled
              tenant={undefined}
              applyButton
            />
          </>
        )}
        {openQuickFilter === 'make' && (
          <>
            <div className={styles.filterHeader}>
              <Typography variant="h6">{strings.make}</Typography>
              <Close onClick={() => setOpenQuickFilter(null)} />
            </div>
            <MakeFilter
              strings={strings}
              locale={locale}
              isPlpFiltersSeoEnabled
              tenant={undefined}
              applyButton
            />
          </>
        )}
        {openQuickFilter === 'model' && (
          <>
            <div className={styles.filterHeader}>
              <Typography variant="h6">{strings.model}</Typography>
              <Close onClick={() => setOpenQuickFilter(null)} />
            </div>
            <ModelFilter
              strings={strings}
              locale={locale}
              isPlpFiltersSeoEnabled
              tenant={undefined}
              applyButton
            />
          </>
        )}
        {openQuickFilter === 'fuelType' && (
          <>
            <div className={styles.filterHeader}>
              <Typography variant="h6">{strings.fuelType}</Typography>
              <Close onClick={() => setOpenQuickFilter(null)} />
            </div>
            <FuelFilter
              strings={strings}
              locale={locale}
              isPlpFiltersSeoEnabled
              tenant={undefined}
              applyButton
            />
          </>
        )}
        {openQuickFilter === 'gearBox' && (
          <>
            <div className={styles.filterHeader}>
              <Typography variant="h6">{strings.gearBox}</Typography>
              <Close onClick={() => setOpenQuickFilter(null)} />
            </div>
            <GearboxFilter
              strings={strings}
              locale={locale}
              isPlpFiltersSeoEnabled
              tenant={undefined}
              applyButton
            />
          </>
        )}
      </div>
    </div>
  );
};

StickyFilterMenus.displayName = 'StickyFilterMenus';
